// UI-only data (mock content not present in SQL): hero copy, promo banner text, testimonials
// Everything else comes from real DB via /src/data.js

export const heroData = {
  eyebrow: 'AEGİS STUDİOS',
  title: 'Efsanevi Güç',
  titleAccent: 'Sunucunuz İçin',
  subtitle:
    'Sunucunuzu; en yüksek kalitede Metin2 PvP dosyaları, özel modeller ve performans odaklı sistemlerle rakiplerinizin bir adım önüne taşıyın.',
  primaryCta: { label: 'Ürünleri Keşfet', href: '/products' },
  secondaryCta: { label: 'Popüler Sistemler', href: '#featured' },
  bgImage:
    'https://cdn.pixabay.com/photo/2019/06/25/12/35/templar-4298112_1280.jpg',
};

export const promoBanner = {
  tag: 'ÖZEL KAMPANYA',
  title: 'Old School Files',
  description: 'Sunucunuzu geliştirilmiş ve açık kaynaklı bir altyapıyla güvence altına alın.',
  levelRange: '1-99',
  edition: 'Old School',
  oldPrice: '20.000 ₺',
  newPrice: '14.999 ₺',
  cta: { label: 'İncele', href: '/products/old-school-server-files' },
  image: 'https://images.pexels.com/photos/12650746/pexels-photo-12650746.jpeg',
};

export const testimonials = [
  {
    name: 'Emre Öztürk',
    role: 'ValorMT2 Kurucusu',
    text: 'Aegis ekibinin PvP files’ı sunucumuzu 3 haftada zirveye taşıdı. İnanılmaz optimize, sıfır crash.',
    avatar: 'https://images.unsplash.com/photo-1618077360395-f3068be8e001?w=200&auto=format&fit=facearea&facepad=3',
  },
  {
    name: 'Selin Akın',
    role: 'Community Manager · CrimsonMT2',
    text: 'Discord destek ekibi 24 saat aktif. Custom sistem taleplerimize haftalar değil günler içinde cevap veriyorlar.',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&auto=format&fit=facearea&facepad=3',
  },
  {
    name: 'Marek K.',
    role: 'Owner · IronBlade EU',
    text: 'Cosmic VPS + DDoS koruma paketiyle ilk gecemizde 2 saldırı göğüslendi — kimse fark etmedi bile.',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&auto=format&fit=facearea&facepad=3',
  },
];

// Category image fallbacks (server didn't have images for some categories)
export const categoryImageFallback = {
  discord: 'https://images.unsplash.com/photo-1614680376573-df3480f0c6ff?w=800&auto=format',
  zindanlar: 'https://images.unsplash.com/photo-1460194436988-671f763436b7?w=800&auto=format',
  maplar: 'https://images.pexels.com/photos/12650746/pexels-photo-12650746.jpeg?w=800',
  models: 'https://images.pexels.com/photos/31350033/pexels-photo-31350033.jpeg?w=800',
};
